module.exports = new __parcel__URL__("pvp_victory_icon.5fc29112.png").toString();